import * as tslib_1 from "tslib";
import { ShadowChunkBase } from "./ShadowChunkBase";
/**
 * ShadowSoftChunk provides a soft shadowing technique by randomly distributing sample points.
 */
var ShadowSoftChunk = (function (_super) {
    tslib_1.__extends(ShadowSoftChunk, _super);
    /**
     * Creates a new ShadowHardChunk.
     */
    function ShadowSoftChunk(method, shader) {
        return _super.call(this, method, shader) || this;
    }
    /**
     * @inheritDoc
     */
    ShadowSoftChunk.prototype._initConstants = function () {
        _super.prototype._initConstants.call(this);
        this._shader.fragmentConstantData[this._fragmentConstantsIndex + 8] = 1 / this._method.numSamples;
        this._shader.fragmentConstantData[this._fragmentConstantsIndex + 9] = 0;
    };
    /**
     * @inheritDoc
     */
    ShadowSoftChunk.prototype._activate = function () {
        _super.prototype._activate.call(this);
        var texRange = .5 * this._method.range / this._method.castingLight.shadowMapper.depthMapSize;
        var data = this._shader.fragmentConstantData;
        var index = this._fragmentConstantsIndex + 10;
        var len = this._method.numSamples << 1;
        for (var i = 0; i < len; ++i)
            data[index + i] = this._method.offsets[i] * texRange;
    };
    /**
     * @inheritDoc
     */
    ShadowSoftChunk.prototype._getPlanarFragmentCode = function (targetReg, regCache, sharedRegisters) {
        // todo: move some things to super
        var decReg = regCache.getFreeFragmentConstant();
        regCache.getFreeFragmentConstant();
        var dataReg = regCache.getFreeFragmentConstant();
        this._fragmentConstantsIndex = decReg.index * 4;
        return this.getSampleCode(decReg, targetReg, regCache, sharedRegisters, dataReg);
    };
    /**
     * Adds the code for another tap to the shader code.
     * @param uv The uv register for the tap.
     * @param texture The texture register containing the depth map.
     * @param decode The register containing the depth map decoding data.
     * @param target The target register to add the tap comparison result.
     * @param regCache The register cache managing the registers.
     * @return
     */
    ShadowSoftChunk.prototype.addSample = function (decodeRegister, targetRegister, registerCache, sharedRegisters, uvReg) {
        var temp = registerCache.getFreeFragmentVectorTemp();
        return this._depthMap._getFragmentCode(temp, registerCache, sharedRegisters, uvReg) +
            "dp4 " + temp + ".z, " + temp + ", " + decodeRegister + "\n" +
            "slt " + uvReg + ".w, " + this._depthMapCoordReg + ".z, " + temp + ".z\n" +
            "add " + targetRegister + ".w, " + targetRegister + ".w, " + uvReg + ".w\n";
    };
    /**
     * @inheritDoc
     */
    ShadowSoftChunk.prototype._activateForCascade = function () {
        _super.prototype._activate.call(this);
        var texRange = this._method.range / this._method.castingLight.shadowMapper.depthMapSize;
        var data = this._shader.fragmentConstantData;
        var index = this._secondaryFragmentConstantsIndex;
        var len = this._method.numSamples << 1;
        data[index] = 1 / this._method.numSamples;
        data[index + 1] = 0;
        index += 2;
        for (var i = 0; i < len; ++i)
            data[index + i] = this._method.offsets[i] * texRange;
        if (len % 4 == 0) {
            data[index + len] = 0;
            data[index + len + 1] = 0;
        }
    };
    /**
     * @inheritDoc
     */
    ShadowSoftChunk.prototype._getCascadeFragmentCode = function (decodeRegister, depthProjection, targetRegister, registerCache, sharedRegisters) {
        this._depthMapCoordReg = depthProjection;
        var dataReg = registerCache.getFreeFragmentConstant();
        this._secondaryFragmentConstantsIndex = dataReg.index * 4;
        return this.getSampleCode(decodeRegister, targetRegister, registerCache, sharedRegisters, dataReg);
    };
    /**
     * Get the actual shader code for shadow mapping
     * @param regCache The register cache managing the registers.
     * @param depthTexture The texture register containing the depth map.
     * @param decodeRegister The register containing the depth map decoding data.
     * @param targetReg The target register to add the shadow coverage.
     * @param dataReg The register containing additional data.
     */
    ShadowSoftChunk.prototype.getSampleCode = function (decodeRegister, targetRegister, registerCache, sharedRegisters, dataReg) {
        var code;
        var uvReg = registerCache.getFreeFragmentVectorTemp();
        registerCache.addFragmentTempUsages(uvReg, 1);
        var offsets = new Array(dataReg + ".zw");
        var numRegs = this._method.numSamples >> 1;
        for (var i = 0; i < numRegs; ++i) {
            var reg = registerCache.getFreeFragmentConstant();
            offsets.push(reg + ".xy");
            offsets.push(reg + ".zw");
        }
        for (i = 0; i < this._method.numSamples; ++i) {
            if (i == 0) {
                var temp = registerCache.getFreeFragmentVectorTemp();
                code = "add " + uvReg + ", " + this._depthMapCoordReg + ", " + dataReg + ".zwyy\n" +
                    this._depthMap._getFragmentCode(temp, registerCache, sharedRegisters, uvReg) +
                    "dp4 " + temp + ".z, " + temp + ", " + decodeRegister + "\n" +
                    "slt " + targetRegister + ".w, " + this._depthMapCoordReg + ".z, " + temp + ".z\n"; // 0 if in shadow;
            }
            else {
                code += "add " + uvReg + ".xy, " + this._depthMapCoordReg + ".xy, " + offsets[i] + "\n" +
                    this.addSample(decodeRegister, targetRegister, registerCache, sharedRegisters, uvReg);
            }
        }
        registerCache.removeFragmentTempUsage(uvReg);
        code += "mul " + targetRegister + ".w, " + targetRegister + ".w, " + dataReg + ".x\n"; // average
        return code;
    };
    return ShadowSoftChunk;
}(ShadowChunkBase));
export { ShadowSoftChunk };



// WEBPACK FOOTER //
// ../dist/lib/chunks/ShadowSoftChunk.js